// La page d'un groupe est passée à React (js/react/ecrans/Groupe.jsx).
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Groupe from "../react/ecrans/Groupe.jsx";

export const rendre = vueReact(Groupe);
